import { LayerType } from '@/views/map/layers/types';
import { Checkbox } from '@mantine/core';
import { useSmallScreen } from '@/hooks/useWindowDimension';
import { useClientTerminology } from '@/hooks/useClientTerminology';
import { EncroachmentLegend } from './EncroachmentLegend';
import type { SelectionProps } from './MapLayerOption';
import { MapLayerOption } from './MapLayerOption';

interface EncroachmentProps extends SelectionProps {
  hasOverhang?: boolean;
  showOverhang?: boolean;
  onOverhangChange?: (e: boolean) => void;
}

export const EncroachmentLayerOption = ({
  hasOverhang = false,
  showOverhang = false,
  onOverhangChange = () => {},
  ...props
}: EncroachmentProps) => {
  const { formatMessage } = useClientTerminology();
  const isSmallScreen = useSmallScreen();

  const isSelected = props.selected === LayerType[LayerType.encroachment];
  return (
    <MapLayerOption
      title={`By ${formatMessage({ id: 'list.encroachmentAnalysisView' }).toLowerCase()}`}
      value={LayerType[LayerType.encroachment]}
      {...props}
    >
      {isSmallScreen && isSelected && <EncroachmentLegend />}
      {hasOverhang && isSelected && (
        <Checkbox
          onChange={(e) => onOverhangChange(e.currentTarget.checked)}
          label="Show only overhang"
          checked={showOverhang}
          name="overhang"
          size="md"
          labelPosition="left"
          styles={{ body: { width: '100%', justifyContent: 'space-between' } }}
        />
      )}
    </MapLayerOption>
  );
};
